<template>
  <div>
    <NavBar></NavBar>
    <div class="center">
      <div class="pic">
        <img src="./img/error.png" alt="" />
      </div>
      <div class="submit-text">
        提交投保信息失败，请
        <span class="color">重新提交</span>
        ！
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from '@/components/h5header'
export default {
  data() {
    return {}
  },
  components: {
    NavBar
  },
  methods: {}
}
</script>
<style scoped lang="less">
.center {
  width: 375px;
}
.pic {
  width: 92.5px;
  height: 92.5px;
  margin: 0 auto;
  margin-top: 147px;
}
.pic img {
  width: 100%;
}
.submit-text {
  margin-top: 15px;
  width: 375px;
  height: 18px;
  line-height: 18px;
  font-size: 18px;
  text-align: center;
}
.color {
  color: #ec4001;
}
</style>
